module.exports = "<span class=\"appUserMessage\"\n   [ngClass]=\"{'warning': isWarning(), 'error': isError()}\">\n   {{_message}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/core/library/app-user-message/app-user-message.component.html
// module id = ../../../../../src/app/core/library/app-user-message/app-user-message.component.html
// module chunks = main